module.exports = __webpack_public_path__ + "static/media/Artboard9.00a8405d.png";